<template>
    <div>
        <h1 class="title step-title"> {{ $t('step-3.title') }} </h1>
        <div class="grid grid-card-icon-rectangle justify-center">
            <card-rectangle
                v-for="{ id, name } in catalog.setpoints"
                :key="id"
                :id="id"
                :title="name[locale]"
                prop="setpoint"
                :width="400"
                @click="handleClick"
            >
            </card-rectangle>
        </div>
    </div>
</template>

<script>
import { GETTERS, MUTATIONS } from "../../../store/wizard/types";
import { mapGetters } from "vuex";
import next from '../../../mixins/next';

export default {
    mixins: [next],

    computed: {
        ...mapGetters({
            catalog: GETTERS.GET_CATALOG
        }),
        setpoint() {
            return this.$store.state.consult.setpoint;
        },
         locale() {
            return this.$route.params.locale;
        }
    },

    watch: {
        setpoint() {
            this.$store.commit(MUTATIONS.RESET_SPECS);
        }
    },

    methods: {
        handleClick() {
            this.$store.commit(MUTATIONS.SET_MAX_STEP_INDEX, 3);
            this.next('specs');
        }
    },
}
</script>
